import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../../../srcCommon/helpers/reselectHelpers';
import {getHasNewEmailTruncation} from '../../../../../../store/featureFlags/featureFlagsSelectors';
import {MessageViewerEmailBody} from './messageViewerEmailBody';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<{}>()(() => ({
  isNewEmailTruncationEnabled: getHasNewEmailTruncation,
}));

export const MessageViewerEmailBodyContainer = connect(mapStateToProps)(MessageViewerEmailBody);
